import { store } from '../store/store';

export default function getTheme(): string {
    return store().theme;
}
